export enum Salutation {
  SIR = 'SIR',

  MADAM = 'MADAM',

  OTHER = 'OTHER',
}
